module.exports = "img/search-icon-vector.c463bb6.svg";